import styled from 'styled-components';
import { InputNumber as InputNumberAtom } from 'components/atoms/input';
import { StyledControl } from 'components/atoms/select';
import { ProgressBar as ProgressBarMolecule } from 'components/molecules/progress-bar';
import { RbacSelect } from 'components/organisms/rbac/components/rbac-select';
import { Content } from 'components/organisms/task-pane/task-detail/task-fields/styled';

export const HorizontallyPaddedContent = styled(Content)`
  padding: 0 var(--spacing-05);
`;

export const ProgressBarContainer = styled(HorizontallyPaddedContent)`
  padding-left: var(--spacing-06);
`;

export const Select = styled(RbacSelect)`
  min-width: 200px;
  background-color: var(--white-100);
`;

export const Control = styled(StyledControl)`
  background-color: var(--white-100);
  border: none;
`;

export const ProgressBar = styled(ProgressBarMolecule)`
  .ant-slider {
    min-width: 96px;
    margin-left: 0;
  }
`;

export const InputNumber = styled(InputNumberAtom)`
  width: 200px;
`;
